import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ReplenishmentTaskPartialPageRBAC = {
  pageID: '47d6e57d9036ce87612d290f169e3199',
  elementID: {
    TableList: 'c09a469efd3dcb976b5190de93f8264b',
    BtnUpdatePartialReplenish: '6c0d40cc71b7300d58e302304f195c47',
  },
} as const

export const useRBACReplenishmentTaskPartialPage = createUseRBAC(
  ReplenishmentTaskPartialPageRBAC.elementID,
)

export type UseRBACReplenishmentTaskPartialPageType = ReturnType<
  typeof useRBACReplenishmentTaskPartialPage
>
